import { fromWei, toWei } from "web3-utils";

/**
 * @param price - in Wei
 * */
const convertWeiToEther = (price: string) => {
  return Number(fromWei(price, "ether"));
};

/**
 * @param price - in Eth
 * */
const convertEtherToWei = (price: string | number) => {
  return toWei(price.toString(), "ether");
};

export { convertWeiToEther, convertEtherToWei };
